import React from 'react';
import useProjectBreadcrumb from 'src/shared/hooks/useProjectBreadcrumb';
import Loader from 'src/shared/components/loader/Loader';
import StandardAppLayout from 'src/shared/components/layout/standard-app-layout/StandardAppLayout';
import { AppName } from 'src/global/globalConfig';
import useProjectFilters from 'src/shared/hooks/useProjectFilters';
import useFeature from 'src/shared/hooks/useFeature';
import { Resources } from 'src/shared/types';
import DemoProjectBanner from 'src/shared/components/demo-project-banner/DemoProjectBanner';
import ProductGate from 'src/shared/components/product-gate/ProductGate';
import { ProductKey } from 'src/shared/types/engine/products';
import Metrics from './components/metrics/Metrics';
import FreemiumDashboard from './components/freemium-dashboard/FreemiumDashboard';
import DashboardFilters from './components/dashboard-filters/DashboardFilters';
import DashboardDataSources from './components/dashboard-data-sources/DashboardDataSources';

const DASHBOARD_TITLE = 'Nature Performance Dashboard';

const DashboardContent = () => {
    const { samplingEventFilterData } = useProjectFilters();
    const currentProjectBreadcrumbDetails = useProjectBreadcrumb(DASHBOARD_TITLE);

    if (!samplingEventFilterData) {
        return (
            <>
                <Loader />
            </>
        );
    }

    return (
        <StandardAppLayout
            mainContent={
                <div>
                    <DashboardDataSources />
                    <DashboardFilters />
                    <Metrics />
                </div>
            }
            breadcrumbs={currentProjectBreadcrumbDetails}
            title={DASHBOARD_TITLE}
            subTitle='Trends and indicators'
            topBanner={<DemoProjectBanner pageName={AppName.DASHBOARD} />}
        />
    );
};

/** The dashboard, for a user who may see Species Insights on this site; the upsell page otherwise. */
const Dashboard = () => {
    const { hasResource } = useFeature();
    const isDashboardAvailable = hasResource({
        resource: Resources.DASHBOARD,
    });

    return (
        <ProductGate product={ProductKey.SPECIES_INSIGHTS} hasResults={isDashboardAvailable} upsell={<FreemiumDashboard />}>
            <DashboardContent />
        </ProductGate>
    );
};

export default Dashboard;
